class MidasHeroVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    this.mobile = matchMedia('(max-width: 749px)');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.userPaused = this.reduced.matches;
    this.inView = true;
    this.video.muted = true;
    this.button.hidden = false;
    this.updateButton = () => {
      const paused = this.video.paused;
      this.button.textContent = paused ? 'Play video' : 'Pause video';
      this.button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    };
    this.playVideo = async () => {
      if (!this.video.getAttribute('src')) this.selectSource();
      try { await this.video.play(); } catch { this.updateButton(); }
    };
    this.selectSource = () => {
      const source = this.mobile.matches ? this.dataset.mobile : this.dataset.desktop;
      if (this.video.getAttribute('src') === source) return;
      this.video.classList.remove('is-ready');
      this.video.src = source;
      this.video.load();
    };
    this.sync = () => {
      if (!this.userPaused && this.inView && !document.hidden) this.playVideo();
      else this.video.pause();
    };
    this.video.addEventListener('playing', () => { this.video.classList.add('is-ready'); this.updateButton(); }, options);
    this.video.addEventListener('pause', this.updateButton, options);
    this.video.addEventListener('error', () => { this.video.classList.remove('is-ready'); this.updateButton(); }, options);
    this.button.addEventListener('click', () => { this.userPaused = !this.video.paused; this.sync(); }, options);
    this.mobile.addEventListener('change', () => {
      if (this.video.getAttribute('src')) { this.selectSource(); this.sync(); }
    }, options);
    this.reduced.addEventListener('change', () => { this.userPaused = this.reduced.matches; this.sync(); }, options);
    document.addEventListener('visibilitychange', this.sync, options);
    this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); });
    this.observer.observe(this);
    this.sync();
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
}
if (!customElements.get('midas-hero-video')) customElements.define('midas-hero-video', MidasHeroVideo);
